import React from "react";
import Card from "../Card";
import Tabs from "../Tabs";
import cn from "classnames";
import Activity from "./Activity";
import styles from "./NFT.module.sass";
import RedeemInfo from "./RedeemInfo";
import { useHistory } from "react-router";
import nft_product from "../../i11/Nft_Product";
import { useUser } from "../../context";

const MockLink =
	"https://media.istockphoto.com/id/1303761470/photo/suspicious-woman-checking-laptop-content-in-the-night.jpg?b=1&s=170667a&w=0&k=20&c=MFhQoVlBVWYaRQ0ORDaGOinZXuZtlVedxomRotJDbkI=";

const NFT = ({ data, redeem, refresh }) => {
	const { locale } = useUser();
	return (
		<Card title={nft_product[locale].nft} classTitle="title-green">
			<div className={styles.container}>
				<div className={styles.top}>
					<div className={styles.img}>
						<img src={data.image || MockLink} alt={data.name} />
					</div>
					<Top data={data} />
				</div>
				<Tabs
					default_={redeem ? 1 : 0}
					head={[nft_product[locale].activity, nft_product[locale].redeem]}
					body={[
						<Activity item={data} />,
						<RedeemInfo refresh={refresh} item={data} />,
					]}
				/>
			</div>
		</Card>
	);
};

const Top = ({ data }) => {
	const { locale } = useUser();
	const history = useHistory();
	return (
		<div className={styles.topLeft}>
			<div className={styles.title}>
				<div className="title">
					{nft_product[locale].token_id} - #{data.tokenId}
				</div>
				<div
					className={styles.pointer}
					onClick={() => {
						history.push(`/customers/list/customer/` + data.owner._id);
					}}
				>
					{nft_product[locale].owner}: {data?.owner?.userName}
				</div>
			</div>
			<div className={styles.title}>
				<div className="title">{data.name}</div>
			</div>
			<div className={styles.statistic}>
				<div className={cn(styles.opacity, styles.cell)}>
					{nft_product[locale].price}
				</div>

				<div className={cn(styles.opacity, styles.cell)}>
					{nft_product[locale].status}
				</div>
				<div className={cn(styles.opacity, styles.cell)}>
					{nft_product[locale].token_type}
				</div>
				<div className={styles.cell}>
					{data.secondaryPrice} {data.currency}
				</div>
				<div className={styles.cell}>{data.status}</div>
				<div className={styles.cell}>{data.tokenType}</div>
			</div>

			<div className={styles.statistic}>
				<div className={cn(styles.opacity, styles.cell)}>
					{nft_product[locale].token_id}
				</div>
				<div className={cn(styles.opacity, styles.cell)}>
					{nft_product[locale].serial}
				</div>
				<div className={cn(styles.opacity, styles.cell)}>{""}</div>
				<div className={styles.cell}>{data.smartContract}</div>
				<div className={styles.cell}>{data.tokenId}</div>
				<div className={styles.cell}>{""}</div>
			</div>
		</div>
	);
};

export default NFT;
